import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    subjectSelect: null,
    subjectSelectName: null,
    chapterSelectName: null,
    chapterSelectId: null,
    topicSelectName: null,
    topicSelectId: null,
    fb: null,
    isFB: false,
  },
  mutations: {
  },
  actions: {

  },
});
